const ajax = require('component-ajax');
const keyCodes = require('key-name');
const dialog = require('dialog-component');
const domify = require('domify');
const delegate = require('emmy/delegate');
const q = require('queried');
const _ = require('./i18n');

const msg = {
  badbrowser: _('Your browser does not support the ability to intercept the selected text or iframe. Perhaps too old version, and perhaps even some kind of mistake.'),
  toobig: _('You have selected too much text!'),
  intextmsg: _('Spelling mistake in the text:'),
  send: _('Send'),
  cancel: _('Cancel'),
  entercmnt: _('Comment for the author:'),
  thankyou: _('Your message has been successfully sent. Thank you for making the world better.'),
};

function getSelection() {
  let selection = null;
  if (window.getSelection) {
    selection = window.getSelection();
  } else if (document.getSelection) {
    selection = document.getSelection();
  } else {
    selection = document.selection;
  }

  const selectedText = `${selection}`;

  if (selection != null) {
    if (selectedText) {
      let infix = selectedText;
      let prefix = '';
      let suffix = '';
      let range;
      let prefixRange;
      let suffixRange;
      const boundingLength = 60;

      if (selection.getRangeAt) {
        range = selection.getRangeAt(0);
        infix = range.toString();

        prefixRange = document.createRange();
        prefixRange.setStartBefore(range.startContainer.ownerDocument.body);
        prefixRange.setEnd(range.startContainer, range.startOffset);
        prefix = prefixRange.toString();

        suffixRange = document.createRange();
        suffixRange.setStart(range.endContainer, range.endOffset);
        suffixRange.setEndAfter(range.endContainer.ownerDocument.body);
        suffix = suffixRange.toString();
      } else if (selection.createRange) {
        range = selection.createRange();
        infix = range.text;

        prefixRange = selection.createRange();
        prefixRange.moveStart('character', -boundingLength);
        prefixRange.moveEnd('character', -infix.length);
        prefix = prefixRange.text;

        suffixRange = selection.createRange();
        suffixRange.moveEnd('character', boundingLength);
        suffixRange.moveStart('character', infix.length);
        suffix = suffixRange.text;
      }

      prefix = prefix.slice(-boundingLength).replace(/[\s\n]+/mg, ' ').replace(/^[^\s]*\s+/, '');
      suffix = suffix.slice(0, boundingLength).replace(/[\s\n]+/mg, ' ').replace(/\s+[^\s]*$/, '');

      return { prefix, infix, suffix };
    }
  } else {
    alert(msg.badbrowser);
  }
}

const template = domify(`
<div>
  <p class="typo-text"></p>
  <form class="typo-form">
    <label class="typo-label" for="typo-comment">${msg.entercmnt}</label>
    <input type="text" maxlength="250" class="typo-comment" name="comment" />
    <div class="typo-buttons">
      <input type="submit" value="${msg.send}" class="typo-submit" />
      <input type="button" value="${msg.cancel}" class="typo-cancel" />
    </div>
  </form>
</div>`);

function createPopup() {
  const popup = dialog(msg.intextmsg, template)
    .addClass('typo-dialog')
    .escapable()
    .closable();

  delegate(popup.el, 'click', '.typo-cancel', () => popup.hide());

  delegate(popup.el, 'click', '.typo-submit', (e) => {
    const prefix = q('.typo-prefix', popup.el);
    const infix = q('.typo-infix', popup.el);
    const suffix = q('.typo-suffix', popup.el);
    const comment = q('.typo-comment', popup.el);

    e.preventDefault();
    ajax.post('/typo/', {
      ref: window.location.origin + window.location.pathname,
      pre: prefix.textContent,
      sel: infix.textContent,
      post: suffix.textContent,
      comment: comment.value,
    }, () => {
      const title = q('.title', popup.el);
      title.parentNode.removeChild(title);

      const body = q('.body', popup.el);
      body.innerHTML = `<p>${msg.thankyou}</p>`;
    });
  });

  return popup;
}

module.exports = function init() {
  document.addEventListener('keyup', (e) => {
    let event = e;
    if (!event) {
      event = window.event;
    }

    /* https://bugs.chromium.org/p/chromium/issues/detail?id=79407 */
    if ((event.keyCode == keyCodes.enter || event.keyCode == 10) && event.ctrlKey) {
      const selection = getSelection();
      if (selection) {
        if (selection.infix.length < 50) {
          const text = `
            <span class="typo-prefix">${selection.prefix}</span>
            <span class="typo-infix">${selection.infix}</span>
            <span class="typo-suffix">${selection.suffix}</span>
          `;
          const popup = createPopup();
          const textNode = q('.typo-text', popup.el);
          textNode.innerHTML = text;

          popup.overlay().show();
        } else {
          alert(msg.toobig);
        }
      }
    }
  });
};
